<template>
  <div class="music-page">
    <!-- 固定顶部导航栏 -->
    <div class="fixed-nav">
      <van-nav-bar class="nav-bar" :title="$t('auth.top51')">
        <template #left>
          <van-icon name="arrow-left" size="22" color="#fff" @click="onClickLeft()" />
        </template>
      </van-nav-bar>
    </div>

    <!-- 内容区域（可滚动） -->
    <div class="music-content">
      <!-- 搜索模块 -->
      <div class="search-wrapper">
        <van-search
          v-model="searchValue"
          :placeholder="$t('auth.top45')"
          shape="round"
          background="transparent"
          @search="onSearch"
        />
      </div>

      <!-- 热门歌曲标题 -->
      <div class="section-header">
        <span class="section-title">{{$t('auth.top44')}}</span>
      </div>

      <!-- 歌曲列表 -->
      <div class="song-list-container">
        <div class="song-item" v-for="item in filteredData" :key="item.id" @click="toDetail(item.id)">
          <!-- 左侧封面 -->
          <img 
            v-if="item.img_url" 
            :src="item.img_url" 
            class="song-thumb" 
            alt=""
          />
          
          <!-- 中间信息 -->
          <div class="song-info">
            <div class="song-name">{{ item.xuanfei_name }}</div>
            <div class="song-artist">
              {{ item.bust }} · 
              <!-- 播放量图标 -->
              <span class="play-count">
                <van-icon name="play-circle-o" size="14PX" color="#999" />
                <span>
                  <span v-if="item.danwei==1">{{ item.dianzan }}{{$t('auth.top42')}}</span>
                  <span v-else>{{ item.dianzan }}{{$t('auth.top41')}}</span>
                </span>
              </span>
            </div>
          </div>

          <!-- 右侧播放按钮 -->
          <div class="play-btn">
            <van-icon name="play-circle-o" size="24PX" color="#00C9A7" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      data: [],
      page: 0,
      ids: 1,
      searchValue: ''
    };
  },
  computed: {
    filteredData() {
      if (!this.searchValue) return this.data;
      const keyword = this.searchValue.toLowerCase();
      return this.data.filter(item => {
        const name = (item.xuanfei_name || '').toLowerCase();
        const artist = (item.bust || '').toLowerCase();
        return name.includes(keyword) || artist.includes(keyword);
      });
    }
  },
  methods: {
    onClickLeft() {
      this.$router.push({ path: '/' });
    },
    onSearch() {
      // 搜索逻辑已通过 computed 实现
    },
    getxuanfeilist() {
      this.$http({
        method: "get",
        url: "xuanfeilist",
        data: { id: this.ids, home_class: 2, page: this.page }
      }).then((res) => {
        this.data = res.data;
        const lanng = localStorage.getItem("lang") || "zh";
        this.data.forEach((item) => {
          if (item.flag) {
            const parts = item.flag.split("|");
            lanng == "zh"
              ? (item.flag = parts[0])
              : lanng == "en"
              ? (item.flag = parts[1])
              : lanng == "ja"
              ? (item.flag = parts[2])
              : (item.flag = parts[3]);
          }
        });
      });
    },
    toDetail(id) {
      this.$router.push({ path: "/detail", query: { id: id } });
    }
  },
  created() {
    this.getxuanfeilist();
  }
};
</script>

<style lang="less" scoped>
.music-page {
  min-height: 100VH;
  background: #f7f8fa;
  display: flex;
  flex-direction: column;
}

/* 固定顶部导航栏 */
.fixed-nav {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 999;
  background: #8600ff;
}

/* 顶部导航栏 */
.nav-bar {
  background: #8600ff !important;
  height: 50PX;
  flex-shrink: 0;
  :deep(.van-nav-bar__title) {
    color: #fff !important;
    font-size: 18PX;
    font-weight: 600;
    text-shadow: 0 2PX 4PX rgba(0, 0, 0, 0.8);
  }
  :deep(.van-icon) {
    color: #fff;
    font-size: 20PX;
  }
}

/* 内容区域（顶部留出导航栏高度） */
.music-content {
  flex: 1;
  padding: 65PX 15PX 30PX;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
}

/* 搜索模块 */
.search-wrapper {
  padding: 15PX 0 10PX;
}

.search-wrapper :deep(.van-search) {
  background: transparent;
}

.search-wrapper :deep(.van-search__content) {
  background: #fff;
  border-radius: 20PX;
  box-shadow: 0 2PX 8PX rgba(0, 0, 0, 0.05);
}

/* 搜索框左侧图标 20PX */
.search-wrapper :deep(.van-search__left-icon) {
  font-size: 20PX;
}

/* 输入框高度 20PX 行高 20PX */
.search-wrapper :deep(.van-field__control) {
  height: 20PX;
  line-height: 20PX;
  font-size: 14PX;
}

/* 热门歌曲标题 */
.section-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 15PX 0;
}

.section-title {
  font-size: 20PX;
  font-weight: 700;
  color: #333;
  letter-spacing: 1PX;
}

.section-more {
  font-size: 13PX;
  color: #999;
  cursor: pointer;
}

/* 歌曲列表 */
.song-list-container {
  padding-bottom: 30PX;
}

.song-item {
  display: flex;
  align-items: center;
  padding: 12PX 0;
  cursor: pointer;
}

.song-item:hover {
  background: rgba(0, 0, 0, 0.03);
  border-radius: 8PX;
}

/* 左侧封面 */
.song-thumb {
  width: 50PX;
  height: 50PX;
  border-radius: 8PX;
  object-fit: cover;
  flex-shrink: 0;
}

/* 中间信息 */
.song-info {
  flex: 1;
  margin-left: 12PX;
  overflow: hidden;
}

.song-name {
  font-size: 16PX;
  font-weight: 600;
  color: #333;
  margin-bottom: 4PX;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.song-artist {
  font-size: 13PX;
  color: #999;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  display: flex;
  align-items: center;
}

/* 播放量图标 */
.play-count {
  display: inline-flex;
  align-items: center;
  gap: 3PX;
  color: #999;
}

/* 右侧播放按钮 */
.play-btn {
  flex-shrink: 0;
  width: 36PX;
  height: 36PX;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  background: rgba(0, 201, 167, 0.1);
  margin-left: 10PX;
}

.play-btn:hover {
  background: rgba(0, 201, 167, 0.2);
}
::v-deep .van-nav-bar__title {
  color: #fff !important;
  font-size: 18PX;
  font-weight: 600;
  text-shadow: 0 2PX 4PX rgba(0, 0, 0, 0.8);
}
::v-deep .van-nav-bar__text {
  color: #fff !important;
}
::v-deep .van-icon{
  font-size: 20PX;
}
::v-deep .van-field__control{
  line-height: 18PX;height: 18PX;font-size: 14PX;
}
</style>